module.exports = __webpack_public_path__ + "img/handraw_mon compte.0a984aad.svg";